uniform float uTime;
uniform float uCloudscale;
uniform float uSpeed;
uniform vec2 uWindDir;
uniform float uClouddark;
uniform float uCloudlight;
uniform float uCloudcover;
uniform float uCloudalpha;

varying vec2 vUv;

const mat2 m = mat2( 1.6,  1.2, -1.2,  1.6 );

vec2 hash( vec2 p ) {
    p = vec2(dot(p,vec2(127.1,311.7)), dot(p,vec2(269.5,183.3)));
    return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}

float noise( in vec2 p ) {
    const float K1 = 0.366025404; 
    const float K2 = 0.211324865; 
    vec2 i = floor(p + (p.x+p.y)*K1);    
    vec2 a = p - i + (i.x+i.y)*K2;
    vec2 o = (a.x>a.y) ? vec2(1.0,0.0) : vec2(0.0,1.0); 
    vec2 b = a - o + K2;
    vec2 c = a - 1.0 + 2.0*K2;
    vec3 h = max(0.5-vec3(dot(a,a), dot(b,b), dot(c,c) ), 0.0 );
    vec3 n = h*h*h*h*vec3( dot(a,hash(i+0.0)), dot(b,hash(i+o)), dot(c,hash(i+1.0)));
    return dot(n, vec3(70.0));    
}

float fbm(vec2 n) {
    float total = 0.0, amplitude = 0.1;
    for (int i = 0; i < 7; i++) {
        total += noise(n) * amplitude;
        n = m * n;
        amplitude *= 0.4;
    }
    return total;
}

void main() {
    vec2 p = vUv;
    vec2 uv = p;  
    
    // NEW: Use 2D vector for time/movement instead of a float
    vec2 timeVec = uTime * uSpeed * uWindDir;
    float q = fbm(uv * uCloudscale * 0.5);
    
    // ridged noise shape
    float r = 0.0;
    uv *= uCloudscale;
    uv = uv - q + timeVec; 
    float weight = 0.8;
    for (int i=0; i<8; i++){
        r += abs(weight*noise( uv ));
        uv = m*uv + timeVec;
        weight *= 0.7;
    }
    
    // noise shape
    float f = 0.0;
    uv = p;
    uv *= uCloudscale;
    uv = uv - q + timeVec;
    weight = 0.7;
    for (int i=0; i<8; i++){
        f += weight*noise( uv );
        uv = m*uv + timeVec;
        weight *= 0.6;
    }
    
    f *= r + f;
    
    // noise colour
    float c = 0.0;
    timeVec = uTime * uSpeed * 2.0 * uWindDir;
    uv = p;
    uv *= uCloudscale*2.0;
    uv = uv - q + timeVec;
    weight = 0.4;
    for (int i=0; i<7; i++){
        c += weight*noise( uv );
        uv = m*uv + timeVec;
        weight *= 0.6;
    }
    
    // noise ridge colour
    float c1 = 0.0;
    timeVec = uTime * uSpeed * 3.0 * uWindDir;
    uv = p;
    uv *= uCloudscale*3.0;
    uv = uv - q + timeVec;
    weight = 0.4;
    for (int i=0; i<7; i++){
        c1 += abs(weight*noise( uv ));
        uv = m*uv + timeVec;
        weight *= 0.6;
    }
    
    c += c1;
    
    vec3 cloudcolour = vec3(1.0) * clamp((uClouddark + uCloudlight*c), 0.0, 1.0);
    f = uCloudcover + uCloudalpha*f*r;
    float cloudDensity = clamp(f + c, 0.0, 1.0);
    
    gl_FragColor = vec4(cloudcolour, cloudDensity);
}